"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var email_addresses_1 = __importDefault(require("email-addresses"));
var lodash_1 = __importDefault(require("lodash"));
var parseOneAddress = function (address) {
    var result = email_addresses_1["default"].parseOneAddress(address);
    if (result && result.address) {
        return result;
    }
    return undefined;
};
var parseAddressList = function (address) {
    var results = email_addresses_1["default"].parseAddressList(address);
    return lodash_1["default"].compact(lodash_1["default"].map(results, function (result) {
        if (result && result.address) {
            return result;
        }
        return null;
    }));
};
exports["default"] = {
    parseOneAddress: parseOneAddress,
    parseAddressList: parseAddressList
};
//# sourceMappingURL=index.js.map